import { useSelector } from 'react-redux';
import LoadingIndicatorView from './LoadingIndicatorView';

/**
 * LoadingIndicator - Global loading indicator for all sync operations
 * Aggregates profile, calendar, and upload operations from loadingSlice.
 * Shows spinner when any operation count > 0, error on failure, offline status.
 */
export default function LoadingIndicator() {
  const operations = useSelector((s) => s.loading.operations);
  const connectionStatus = useSelector((s) => s.loading.connectionStatus);

  // Aggregate across all operation types
  const totalCount = Object.values(operations).reduce((sum, op) => sum + op.count, 0);
  const anyError = Object.values(operations).find(op => op.error);

  // Show if any operation active, if there's an error, OR if offline
  const shouldShow = totalCount > 0 || anyError || connectionStatus === 'offline';

  // Determine message
  let message = 'Updating...';
  if (anyError) {
    message = anyError.error;
  } else if (connectionStatus === 'offline') {
    message = 'Offline';
  } else if (operations.chats?.count > 0) {
    message = 'Loading chats...';
  } else if (operations.calendarLoad?.count > 0) {
    message = 'Loading...';
  } else if (operations.messages?.count > 0) {
    message = 'Loading messages...';
  }

  // For error or offline state, force count to 1 so indicator stays visible
  const displayCount = (anyError || connectionStatus === 'offline') ? 1 : totalCount;

  // Determine status
  const displayStatus = anyError ? 'error' : (connectionStatus === 'offline' ? 'error' : (totalCount > 0 ? 'syncing' : 'idle'));

  if (!shouldShow) return null;

  return (
    <div className="fixed top-0.5 left-0.5 z-[100]">
      <LoadingIndicatorView
        count={displayCount}
        message={message}
        status={displayStatus}
      />
    </div>
  );
}
